import { render, staticRenderFns } from "./TOSView.vue?vue&type=template&id=6f643c35&scoped=true"
import script from "./TOSView.vue?vue&type=script&setup=true&lang=js"
export * from "./TOSView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TOSView.vue?vue&type=style&index=0&id=6f643c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f643c35",
  null
  
)

export default component.exports